import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import dayjs from "dayjs";
import dayjsPluginUTC from "dayjs/plugin/utc";
dayjs.extend(dayjsPluginUTC);

import { toast } from "react-toastify";

//CUSTOM COMPONENT
import Area from "../../../aGlobalDesign/Area/Area";
import PaginationList from "../../../aGlobalDesign/Pagination/PaginationList";
import Badge from "../../../aGlobalDesign/Badges/Badge";

class WaitingList extends React.Component {

    constructor() {
        super();
        this.state = {
            searchField: "",
            forcePaginationUpdate: 0,
            reload: new URLSearchParams(new URL(window.location.href).search).get("reload"),
            appcallsList: null
        };
    }
    componentDidMount() {
        this.props.changeAppBarTitle(strings.WaitingList);
        this.props.ChangeCurrentMenuName("WaitingList");

        if (!this.props.monitoring.secondarycallcenters) {
            this.props.GetSecondaryCallCentersList((data) => {});
        }
    }
    forcePaginationUpdate = () => {
        this.setState(s => ({
            selectedCallCenter: null,
            forcePaginationUpdate: s.forcePaginationUpdate + 1
        }));
    };
    componentDidUpdate(prevProps) {
        const reload = new URLSearchParams(new URL(window.location.href).search).get("reload");
        if (reload && this.state.reload !== reload) {
            this.setState({ reload: reload });
            this.forcePaginationUpdate();
        }
    }
    getStatus(stat) {
        switch (stat) {
            case 60 : return "Appel en cours";
            case 45 : return "File d'attente";
            case 10 : return "Hors ligne";
            case 20 : return "Hors ligne";
            case 30 : return "Mode sleep";
            case 40 : return "Disponible";
            case 50 : return "Appel entrant";
            case 70 : return "Mode absence";
            default : return "Pas de statut";
        }
    }
    getCallLink(ca) {
        if (!ca || !ca.callLinkGuid) {return null;}
        if (this.props.monitoring.secondaryFreeCallLinks) {
            const fcl = this.props.monitoring.secondaryFreeCallLinks.results.find(fc => fc.guid === ca.callLinkGuid);
            if (!fcl) {return null;}
            return fcl.link;
        }
    }
    getDevice(dt) {
        switch (dt) {
            case "mobile" : return strings.Mobile;
            case "pc" : return strings.Computer;
            case "" : return strings.Capsule;
            case null : return strings.Capsule;
            case undefined : return strings.Capsule;
            default : return dt;
        }
    }
    //#endregion

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const orgId = this.props.currentuser.currentorganization.id;
        const cucallCenterId = this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).callCenterId;
        const sortedList = this.props.monitoring.callapps ? this.props.monitoring.callapps.map((ca, index) => {
            if (ca && ca.callCenter && ca.callCenter.id === cucallCenterId && ca.status === 45) {
                return { ca: ca, time: dayjs.utc(ca.dateStart).local().format("HH:mm:ss") };
            }
        }) : [];
        return <>
            <Area
                helmet={strings.helmetWaitingList}
                title={strings.WaitingList}
                information={<Badge text={sortedList.filter((obj) => obj !== undefined).length + " " + strings.activeFlux } styleColor="grey"/>}
            >
                <PaginationList
                    forcePaginationUpdate={this.state.forcePaginationUpdate}

                    onGetElements={
                        (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => {
                            const accessRight = this.props.currentuser.accessrights ? this.props.currentuser.accessrights.hasPermission(420, "consult") : 0;
                            setTimeout(() => {
                                const result = {
                                    pageNumber: pageNumber,
                                    pageSize: 1000,
                                    sortExpression: sortExpression,
                                    filterExpression: filterExpression,
                                    tagSearchRequest: tagSearchRequest,
                                    PaginationType: this.props.administration.paginationtypewebcall ? this.props.administration.paginationtypewebcall : PaginationType,
                                    results: this.props.monitoring.callapps ? this.props.monitoring.callapps.map(ca => {
                                        if (ca && ca.callCenter && ca.callCenter.id === cucallCenterId && ca.status === 45) {
                                            return ca;
                                        }
                                    }) : []
                                };
                                onSuccess(this.props.monitoring.callapps ? result : null);
                                this.setState({
                                    appcallsList: result
                                });
                            }, 200);
                        }
                    }
                    onSavePagination={(paginationType) => {
                        this.props.EditPaginationListType("waitinglist", paginationType);
                        this.setState({ appcallsList: { ...this.state.appcallsList, PaginationType: paginationType } });
                    }}
                    myElements={{ ...this.state.appcallsList,
                        PaginationType: this.props.administration && this.props.administration.paginationtypewaitinglist ? this.props.administration.paginationtypewaitinglist : this.state.appcallsList ? this.state.appcallsList.PaginationType : null,
                        results: sortedList
                    }}

                    sortOptions={[
                        { sortName: "name", sortData: "asc" }
                    ]}

                    tableElement={(rawelement, onReloadList) => {
                        const element = rawelement && rawelement.ca ? rawelement : rawelement ? { ca: rawelement } : null;
                        return [
                            {
                                colTitle: strings.Position,
                                fixedWidth: "100px",
                                lockWidth: true,
                                colContent: element ? String(element.ca.position).padStart(3, "0") : null
                            },
                            {
                                colTitle: strings.WaitTime,
                                fixedWidth: "220px",
                                lockWidth: true,
                                justify: "center",
                                colContent: element && element.time ? element.time : null
                            },
                            {
                                colTitle: strings.Zone,
                                fixedWidth: "200px",
                                colContent: element && element.ca.zone ? element.ca.zone.name : null
                            },
                            {
                                colTitle: strings.CallCenters,
                                fixedWidth: "200px",
                                colContent: element && element.ca.callCenter ? element.ca.callCenter.name : null
                            },
                            {
                                colTitle: strings.Type,
                                fixedWidth: "150px",
                                lockWidth: true,
                                colContent: element ? element.ca.callLinkGuid ? strings.CallApp : strings.Capsule : null
                            },
                            {
                                colTitle: strings.Device,
                                fixedWidth: "150px",
                                lockWidth: true,
                                colContent: element ? this.getDevice(element.ca.deviceType) : strings.Capsule
                            }
                        ];
                    }}
                />
            </Area>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(WaitingList);
